import { PubsubTopic } from "@megaron/pubsub-contracts";
import { Serializers, SerializerValue } from "@megaron/serializers";

export const accountChangedTopic = PubsubTopic({
  name: "accounts-account-changed",
  serializer: Serializers.object({
    accountUuid: Serializers.string,
    changeType: Serializers.stringOneOf(
      "userPreregistered",
      "userJoined",
      "userRegistered",
      "profileUpdated",
      "emailVerified",
      "accountDeleted",
    ),
  }),
});

export type AccountChangedMessage = SerializerValue<typeof accountChangedTopic.serializer>;

export const accountsTopics = [accountChangedTopic];
